/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router'
import { Button, Table, message, Modal } from 'antd';
import { DmsTab, DataList, RemarkModal, UploadFile } from 'Components';
import { list as getLinkmanList, createAccount } from '../../service/channel/linkman';
import { accountResetPwd, accountInvalid } from '../../service/account';
import { getList as getRemarkList, deleteRemarks } from '../../service/remark/remark'
import { getList as getFileList, deleteFiles, addFileDownCount } from '../../service/remark/file'
import { list as getStoreList } from '../../service/store'
import { getOrderList } from '../../service/order';
import { detail } from '../../service/channel';
import { config, formatMoney } from 'Utils';
const confirm = Modal.confirm;

class ChannelDetail extends React.Component {
  constructor (props) {
    super(props);
    //this.store = CounterStore;
    //this.storeKeys = ['currentItem'];
    this.state = {
      channelId: this.props.params.channelId,
      detail: {},
      linkmans: [],
      remarks: [],
      files: [],
      stores: [],
      orders: [],
      orderTotal: 0,
      storeTotal: 0,
      fileTotal: 0,
      linkmanTotal: 0,
      remarkTotal: 0,
      searchObj: {
        customerName: '',
        startCreatedDate: '',
        endCreatedDate: '',
        areaId: '',
        orderStatus: 0,
        payStatus: '',
        s: 10,
        p: 1
      }
    }
    this.getFiles = this.getFiles.bind(this);
    this.getOrders = this.getOrders.bind(this);
    this.getLinkman = this.getLinkman.bind(this);
    this.getDetail = this.getDetail.bind(this);
    this.getRemarks = this.getRemarks.bind(this);
    this.getStores = this.getStores.bind(this);
  }

  componentDidMount () {
    this.getFiles();
    this.getDetail();
    this.getStores();
    this.getLinkman();
    this.getRemarks();
  }

  goView (url) {
    hashHistory.push(url);
  }

  goBack () {
    hashHistory.goBack();
  }

  openModal () {
    this.remarkModal.showModal();
  }

  getDetail () {
    const self = this;
    detail(self.state.channelId).then(res => {

      self.setState({
        ...this.state,
        detail: res.data.dmsChannel
      })
      self.getOrders(res.data.dmsChannel.name);
    })
  }

  getOrders (name) {
    const self = this;
    getOrderList({ customerName: name, s: 5, p: 1 }).then(res => {
      self.setState({
        ...this.state,
        orders: res.data,
        orderTotal: res.total
      })
    });
  }

  getLinkman () {
    const self = this;
    getLinkmanList({ channelId: this.state.channelId, p: 1, s: 5 }).then(res => {
      self.setState({
        ...this.state,
        linkmans: res.data,
        linkmanTotal: res.total
      })
    })
  }

  getRemarks () {
    const self = this;
    getRemarkList({ relatedTableType: 1, relatedTableId: self.state.channelId, p: 1, s: 5 }).then(res => {

      self.setState({
        ...this.state,
        remarks: res.data,
        remarkTotal: res.total
      })
    })
  }

  deleteRemark (id) {
    const self = this;
    confirm({
      title: '确定要删除这条记录?',
      //content: 'Some descriptions',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteRemarks({ id }).then(res => {
          message[res.status ? 'success' : 'error'](res.message);
          res.status && self.getRemarks();
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  getStores () {
    const self = this;
    getStoreList({ belongDealer: self.state.channelId, p: 1, s: 5 }).then(res => {

      self.setState({
        ...this.state,
        stores: res.data,
        storeTotal: res.total
      })
    })
  }

  getFiles () {
    const self = this;
    getFileList({ dealType: 1, id: self.state.channelId, p: 1, s: 5 }).then(res => {

      self.setState({
        ...this.state,
        files: res.data,
        fileTotal: res.total
      })
    })
  }

  deleteFile (id) {
    const self = this;
    confirm({
      title: '确定要删除附件?',
      //content: 'Some descriptions',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteFiles({ ids: [id] }).then(res => {
          message[res.status ? 'success' : 'error'](res.message);
          res.status && self.getFiles();
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  downCount (id) {
    const self = this;
    addFileDownCount({ id }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getFiles();
    })
  }

  createAccount (linkmanId) {
    const self = this;
    createAccount({ id: linkmanId }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getLinkman();
    })
  }

  invalidAccount (accountId) {

    const self = this;
    accountInvalid({ id: accountId }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getLinkman();
    })
  }

  resetPwd (accountId) {

    const self = this;
    accountResetPwd({ id: accountId }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getLinkman();
    })
  }

  render () {
    const self = this;
    const {
      detail, channelId,
      linkmans, files, remarks, stores, orders,
      fileTotal, linkmanTotal, remarkTotal, storeTotal, orderTotal
    } = this.state;
    const cells = {
      code: {
        title: '渠道编码'
      },
      sortName: {
        title: '简称'
      },
      channelTypeText: {
        title: '渠道类型'
      },
      areaText: {
        title: '所属区域'
      },
      parentText: {
        title: '上级渠道'
      },
      rankText: {
        title: '渠道等级'
      },
      productList: {
        title: '销售产品',
        render: arr => arr ? arr.map(x => x.categoryName).join() : ''
      },
      areaList: {
        title: '销售区域',
        render: arr => arr ? arr.map(x => x.areaName).join() : ''
      },
      address: {
        title: '地址',
        render: text => `${detail.provinceText || ''}${detail.cityText || ''}${detail.countyText || ''}${text || ''}`
      },
      companyIncome: {
        title: '年度收入',
        render: () => detail.companyIncome ? `${detail.companyIncome}万元` : ''
      },
      employeeNum: {
        title: '员工总数'
      },
      companyCeo: {
        title: 'CEO'
      },
      compnyPhone: {
        title: '电话'
      },
      companyWebsite: {
        title: '网址'
      },
      companyFax: {
        title: '传真'
      },
      employeeText: {
        title: '业务员'
      },
      createdDate: {
        title: '创建时间',
        render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : '----'
      },
      lastUpdatedDate: {
        title: '最后更新',
        render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : '----'
      },
    };
    const orderProps = {
      rowKey: 'id',
      columns: [
        {
          title: '订单编号',
          dataIndex: 'code',
          render: (text, record, index) => {
            return <a href={`#/order/${record.id}`}>{text}</a>
          }
        }, {
          title: '下单时间',
          dataIndex: 'createdDate',
          render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : ''
        }, {
          title: '订单金额(元)',
          dataIndex: 'amount',
          render: text => <span style={{ color: '#d61518' }}>{'¥' + formatMoney(text)}</span>
        }, {
          title: '订单状态',
          dataIndex: 'sellerOrderStatusText'
        }
      ],
      dataSource: orders
    };
    const storeProps = {
      rowKey: 'id',
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          render: (text, record, index) => {
            return <a href={`#/store/${record.id}`}>{text}</a>
          }
        }, {
          title: '地址',
          dataIndex: 'storeAddress',
          render: (text, record, index) => {
            return `${record.provinceText || ''}${record.cityText || ''}${record.countyText || ''}${text || ''}`;
          }
        }, {
          title: '店长',
          dataIndex: 'shopowner'
        }, {
          title: '运营方式',
          dataIndex: 'operateWayText',
        }, {
          title: '类型',
          dataIndex: 'storeTypeText',
        }, {
          title: '员工总数',
          dataIndex: 'storeEmployeeNum'
        }, {
          title: '状态',
          dataIndex: 'active',
          render: (text, record, index) => {
            if (text === 0) return '已停运';
            if (text === 1) return '运营中';
            return '';
          }
        }
      ],
      dataSource: stores
    };
    const linkmanProps = {
      rowKey: 'id',
      columns: [
        {
          title: '姓名',
          dataIndex: 'name',
          render: (text, record, index) => <a href={`#/linkman/${channelId}/${record.id}`}>{text}</a>
        },
        {
          title: '性别',
          dataIndex: 'sexText',
        },
        {
          title: '手机',
          dataIndex: 'contactInfoList',
          render: (arr, record, index) => {
            if (arr) {
              let list = arr.filter(x => x.type == 1);
              return list.length ? list[0].content : ''
            }
            return ''
          }
        },
        {
          title: '岗位',
          dataIndex: 'post',
        },
        {
          title: '账号',
          dataIndex: 'userId',
          render: (userId, record, index) => {
            if (userId && record.contactInfoList) {
              let list = record.contactInfoList.filter(x => x.type == 1);
              return list.length ? list[0].content : ''
            }
            return ''
          }
        },
        {
          title: '操作',
          dataIndex: '',
          width: '200px',
          render: (text, record, index) => record.userId ? <span>
            <a onClick={self.invalidAccount.bind(self, record.userId)}>禁用账号</a>&nbsp;&nbsp;&nbsp;
            <a onClick={self.resetPwd.bind(self, record.userId)}>重置密码</a>
          </span> : <span>
            <a onClick={self.createAccount.bind(self, record.id)}>开通账号</a>
          </span>
        },
      ],
      dataSource: linkmans
    };
    const fileProps = {
      rowKey: 'id',
      columns: [
        {
          title: '标题',
          dataIndex: 'fileName',
        },
        {
          title: '创建时间',
          dataIndex: 'createdDate',
          render: (text) => new Date(text).format('yyyy-MM-dd hh:mm')
        },
        {
          title: '下载次数',
          dataIndex: 'downloadCount',
        },
        {
          title: '类型',
          dataIndex: 'extension',
        },
        {
          title: '大小',
          dataIndex: 'size',
          render: (text, record, index) => text.bytesToSize()
        },
        {
          title: '操作',
          dataIndex: 'fileId',
          render: (text, record, index) => <span>
            <a href={`${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${text}`}
               onClick={this.downCount.bind(self, text)}>下载</a>&nbsp;&nbsp;&nbsp;
            <a onClick={this.deleteFile.bind(self, text)}>删除</a>
          </span>
        },
      ],
      dataSource: files
    };
    const remarkProps = {
      rowKey: 'id',
      columns: [
        {
          title: '主题',
          dataIndex: 'content',
        },
        {
          title: '创建时间',
          dataIndex: 'createdDate',
        },
        {
          title: '操作',
          dataIndex: '',
          render: (text, record, index) => <span><a onClick={self.deleteRemark.bind(self, record.id)}>删除</a></span>
        },
      ],
      dataSource: remarks
    };
    return <div className="dms-main-box">
      <div>
        <DmsTab options={[`渠道详情 -- ${detail.name || ''}`]} defaultKey={0}>
          <Button onClick={this.goView.bind(this, `/channel/add/${channelId}`)}>编辑</Button>
          <Button onClick={this.goBack}>返回</Button>
        </DmsTab>
        <div className="dms-table-box">
          <DataList cells={cells} data={detail}></DataList>
        </div>
      </div>
      <div>
        <DmsTab className="white-bg no-border" options={['订单']} defaultKey={0}/>
        <div className="dms-table-box">
          <Table {...orderProps} bordered pagination={false}/>
          <br />
          {!!orderTotal &&
          <p><a
            onClick={this.goView.bind(this, `/order?channelId=${channelId}&channelName=${detail.name}`)}>查看全部（{orderTotal}）</a>
          </p>
          }
        </div>
      </div>
      <div className="dms-split-bar"></div>
      <div>
        <DmsTab className="white-bg no-border" options={['联系人']} defaultKey={0}>
          <Button type="primary" onClick={this.goView.bind(this, `/linkman/${channelId}/add/0`)}>新增联系人</Button>
        </DmsTab>
        <div className="dms-table-box">
          <Table {...linkmanProps} bordered pagination={false}/>
          <br />
          {!!linkmanTotal &&
          <p><a onClick={this.goView.bind(this, `/linkman/${channelId}`)}>查看全部（{linkmanTotal}）</a></p>}
        </div>
      </div>
      <div className="dms-split-bar"></div>
      <div>
        <DmsTab className="white-bg no-border" options={['门店']} defaultKey={0}>
          <Button type="primary"
                  onClick={this.goView.bind(this, `/store/add/0?belongDealer=${channelId}`)}>新增门店</Button>
        </DmsTab>
        <div className="dms-table-box">
          <Table {...storeProps} bordered pagination={false}/>
          <br />
          {!!storeTotal &&
          <p><a
            onClick={this.goView.bind(this, `/store?belongDealer=${channelId}&dealerName=${detail.name}`)}>查看全部（{storeTotal}）</a>
          </p>
          }
        </div>
      </div>
      <div className="dms-split-bar"></div>
      <div>
        <DmsTab className="white-bg no-border" options={['附件']} defaultKey={0}>
          <UploadFile color="red" entityType="channel" entityId={channelId} onSuccess={this.getFiles}/>
        </DmsTab>
        <div className="dms-table-box">
          <Table {...fileProps} bordered pagination={false}/>
          <br />
          {!!fileTotal &&
          <p><a
            onClick={this.goView.bind(this, `/file?entityId=${channelId}&entityType=channel`)}>查看全部（{fileTotal}）</a>
          </p>}
        </div>
      </div>
      <div className="dms-split-bar"></div>
      <div>
        <DmsTab className="white-bg no-border" options={['备注']} defaultKey={0}>
          <Button type="primary" onClick={this.openModal.bind(this)}>新建备注</Button>
        </DmsTab>
        <div className="dms-table-box">
          <Table {...remarkProps} bordered pagination={false}/>
          <br />
          {!!remarkTotal &&
          <p><a
            onClick={this.goView.bind(this, `/remark?entityId=${channelId}&entityType=channel`)}>查看全部（{remarkTotal}）</a>
          </p>}
        </div>
      </div>
      <RemarkModal ref={(node) => {
        this.remarkModal = node;
      }}
                   entityType="channel"
                   entityId={channelId}
                   onSuccess={this.getRemarks}/>
    </div>
  }
}
;
export default ChannelDetail;



// WEBPACK FOOTER //
// ./src/routes/channel/detail.js